"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassUtil = void 0;
var ClassUtil = /** @class */ (function () {
    function ClassUtil() {
    }
    /**
     * To Simple Object without type. It will to convert str into null, boolean, double, long or Integer.
     * For number, it supports Hex number with prefix of "0x". If conversion fails. It will return the original str.
     */
    ClassUtil.toSimpleObject = function (str) {
        if ("null" === str)
            return null;
        if ("true" === str)
            return true;
        if ("false" === str)
            return false;
        return this.tryToNumber(str);
    };
    ClassUtil.tryToNumber = function (str) {
        if (str.length > 0) {
            return this.parseNumber(str);
        }
        return str;
    };
    ClassUtil.parseNumber = function (str) {
        var isDouble = str.indexOf('.') >= 0;
        var num = Number(str);
        return Number.isNaN(num) || (!isDouble && num > Number.MAX_SAFE_INTEGER) ? str : num;
    };
    return ClassUtil;
}());
exports.ClassUtil = ClassUtil;
//# sourceMappingURL=ClassUtil.js.map